
export const parseAiRecommendationPercentageScore = (score)=> {
    return parseInt(score);
}